import React from "react";
import { Link } from "react-router-dom";

const SpecialOffer = () => {
  return (
    <>
      <section
        className="space position-relative"
        style={{ backgroundImage: "url(/assets/img/bg/offer-bg.jpg)" }}
      >
        <div className="container">
          <div className="row align-items-center justify-content-between">
            <div className="col-xxl-5 col-xl-5 col-lg-6 col-md-6">
              <div className="title-area white-title mb-md-0">
                <span className="sec-subtitle">Exclusive Offer</span>
                <h2 className="sec-title h1">
                  Get Special Discounts on Your Stay
                </h2>
                <p className="sec-text">
                  Looking for a home away from home in Dubai? Take advantage of
                  our special offers on both short-term and long-term stays!
                  Enjoy comfortable, fully furnished apartments, and villas at
                  unbeatable prices.
                </p>
                <Link to="/contact" className="vs-btn style2">
                  Book Now
                </Link>
              </div>
            </div>
            <div className="col-xxl-5 col-xl-5 col-lg-6 col-md-6">
              <div className="img-box1">
                <img
                  className="img-1-1"
                  src="/assets/img/shape/offer-1-1.png"
                  alt="Special Offer"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SpecialOffer;
